/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_SagaInputs */

const id_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const ms_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const da_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-sagaen`)
};

const de_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-Saga`)
};

const en_us2_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker saga`)
};

const es_es2_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const es_mx2_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const fil_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker saga`)
};

const fr_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const it_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const hu_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker saga`)
};

const nl_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-saga`)
};

const no_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-sagaen`)
};

const pl_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sagi Skywalker`)
};

const pt_br2_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saga Skywalker`)
};

const pt_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const ro_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const fi_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-saagasta`)
};

const sv_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker-sagan`)
};

const vi_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saga Skywalker`)
};

const tr_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker saga`)
};

const cs_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ságy Skywalker`)
};

const bg_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`сагата Skywalker`)
};

const ru_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`саги о Скайуокерах`)
};

const uk_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Саги Скайвокерів`)
};

const ar_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملحمة Skywalker`)
};

const hi_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्काईवॉकर गाथा`)
};

const th_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มหากาพย์ Skywalker`)
};

const ja_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スカイウォーカー・サーガ`)
};

const zh_cn2_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天行者传奇`)
};

const zh_hant1_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天行者傳奇`)
};

const ko_misc_posts_saga = /** @type {(inputs: Misc_Posts_SagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skywalker 사가`)
};

/**
* | output |
* | --- |
* | "Skywalker saga" |
*
* @param {Misc_Posts_SagaInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_saga = /** @type {((inputs?: Misc_Posts_SagaInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_SagaInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_saga(inputs)
	if (locale === "ms") return ms_misc_posts_saga(inputs)
	if (locale === "da") return da_misc_posts_saga(inputs)
	if (locale === "de") return de_misc_posts_saga(inputs)
	if (locale === "en-US") return en_us2_misc_posts_saga(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_saga(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_saga(inputs)
	if (locale === "fil") return fil_misc_posts_saga(inputs)
	if (locale === "fr") return fr_misc_posts_saga(inputs)
	if (locale === "it") return it_misc_posts_saga(inputs)
	if (locale === "hu") return hu_misc_posts_saga(inputs)
	if (locale === "nl") return nl_misc_posts_saga(inputs)
	if (locale === "no") return no_misc_posts_saga(inputs)
	if (locale === "pl") return pl_misc_posts_saga(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_saga(inputs)
	if (locale === "pt") return pt_misc_posts_saga(inputs)
	if (locale === "ro") return ro_misc_posts_saga(inputs)
	if (locale === "fi") return fi_misc_posts_saga(inputs)
	if (locale === "sv") return sv_misc_posts_saga(inputs)
	if (locale === "vi") return vi_misc_posts_saga(inputs)
	if (locale === "tr") return tr_misc_posts_saga(inputs)
	if (locale === "cs") return cs_misc_posts_saga(inputs)
	if (locale === "bg") return bg_misc_posts_saga(inputs)
	if (locale === "ru") return ru_misc_posts_saga(inputs)
	if (locale === "uk") return uk_misc_posts_saga(inputs)
	if (locale === "ar") return ar_misc_posts_saga(inputs)
	if (locale === "hi") return hi_misc_posts_saga(inputs)
	if (locale === "th") return th_misc_posts_saga(inputs)
	if (locale === "ja") return ja_misc_posts_saga(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_saga(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_saga(inputs)
	return ko_misc_posts_saga(inputs)
});
export { misc_posts_saga as "misc.posts.saga" }